import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Link } from 'react-router-dom';
import DeleteModal from '../../common/delete_modal';
import services from '../../../services';
import ConfirmationModal from '../../common/confirmationModal';
import Swal from "sweetalert2";
import $ from "jquery";

var SeloSelected = null;

export function TabelAction({ rowbuttonAction, actionbuttons, deleteFunc }) {
    return class extends GridCell {
        /* Primeiro passo na acomodação da classe */

        constructor(props) {
            super(props);
            this.state = {
                showPreview: false,
                previewImage: null
              };
        }
        componentDidMount() {
            document.body.addEventListener('click', this.handleClickOutside);
          }
        
          componentWillUnmount() {
            document.body.removeEventListener('click', this.handleClickOutside);
          }
        
         
        
          handleClickOutside = (event) => {
            if(event.target.className != "ImageRotulos"){
                this.setState({
                    showPreview: false
                });
            
            }   
          }
        /*  Para renderizar o conteúdo html da página   */
        togglePreview = (imageData) => {
            this.setState({
              showPreview: true,
              previewImage: imageData
            });
          }
          
        actionSelosPedidos = (selo) => {

            SeloSelected = selo; 
            
            Swal.fire({
                title: 'Deseja aceitar ou recusar o Pedido?',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Aceitar',
                denyButtonText: 'Recusar',
                cancelButtonText: "Cancelar"
            }).then((result) => {

                (async () => {  

                    if (result.isConfirmed) {
                    
                        var Selo = {
                            idpedidoselosetiquetas : SeloSelected.idPedidoSelosEtiquetas,
                            estado : true,
                            modificadopor : window.localStorage.getItem('username')
                        };  

                        let update = await services.apiCall.requestApi(
                            "/Fiscalizacao/UpdateStatePedidoSelosEtiquetasPendentes",
                            Selo,
                            "get"
                        );
                        if(update){
                            $('#searchButton').trigger('click');
                        }

                    } else if (result.isDenied) {

                        var Selo = {
                            idpedidoselosetiquetas : SeloSelected.idPedidoSelosEtiquetas,
                            estado : false,
                            modificadopor : window.localStorage.getItem('username')
                        };

                        let update = await services.apiCall.requestApi(
                            "/Fiscalizacao/UpdateStatePedidoSelosEtiquetasPendentes",
                            Selo,
                            "get"
                        );
                        if(update){
                            $('#searchButton').trigger('click');
                        }
                            
                    }

                })();
            })

        }

        render() {
            const { dataItem } = this.props;
            const { showPreview, previewImage } = this.state;
            console.log(dataItem);

            let urlAnexo = '';
            if(dataItem.anexo){
                dataItem.anexo.forEach((element) => {
                    if (showPreview && previewImage === element && element.nome.includes(".pdf")) {
                      const byteCharacters = atob(element.anexo);
                      const byteNumbers = new Array(byteCharacters.length);
                      for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                      }
                      const byteArray = new Uint8Array(byteNumbers);
                      const blob = new Blob([byteArray], { type: 'application/pdf' });
                      urlAnexo = URL.createObjectURL(blob);
                     
                    }
                });
            }
            
            // console.log(dataItem);
            if (!dataItem.field) {
                return (
                    
                    <td className="k-command-cell">
                        <Tooltip anchorElement="target" position="top" color="#808080">
                            <div className="action">
                                {
                                    actionbuttons.Add
                                    && <span onClick={() => rowbuttonAction('Add', dataItem)}><i title="Adicionar" className="fas fa-plus-circle text-active mr-2" /></span>

                                }
                                {
                                    actionbuttons.Edit
                                    && <span onClick={() => rowbuttonAction('Edit', dataItem)}><span title="Consultar registo" className="k-icon k-i-redo cursor-pointer" /></span>

                                }
                                {
                                    // actionbuttons.Image &&
                                    //     <spam className="attachment-cell ImageRotulosTd">
                                    //     {dataItem.anexo.map((element, index) => (
                                    //       <span key={index} className="attachment-wrapper" onClick={() => this.togglePreview(element)}>
                                    //         {/* Display an icon or thumbnail here */}
                                    //         <i title="Visualizar Imagem do Rótulo" className="fas fa-file-pdf" />
                                    //         {/* Preview of the image */}
                                    //         {showPreview && previewImage === element && (
                                    //           <div className="preview">
                                    //             {element.nome.includes(".pdf") ? (
                                    //                 <object
                                    //                 key={index}
                                    //                 data={urlAnexo}
                                    //                 type="application/pdf"
                                    //                 width="100%"
                                    //                 height="100%"
                                    //               >
                                    //                 <img className="ImageRotulos" src={urlAnexo} alt="Preview" />
                                    //               </object>
                                    //             ) : (
                                    //               <img className='ImageRotulos' src={`data:image/png;base64,${element.anexo}`} alt="Preview" />
                                    //             )}
                                    //           </div>
                                    //         )}
                                    //       </span>
                                    //     ))}
                                    //   </spam>
                                }
                                {
                                    actionbuttons.Arrow
                                    && (
                                        <span>
                                            <i aria-hidden="true" data-toggle="dropdown">
                                                <span title={actionbuttons.Arrow} className="k-icon k-i-arrow-right mr-2"> </span>
                                            </i>
                                            <div className="dropdown-menu">
                                                <span className="closetooltip"><i className="fas fa-times-circle" /></span>
                                                {/* <span className="dropdown-item mt-2" href="#" onClick={() => rowbuttonAction("Verificar pagamento", dataItem)} >Verificar pagamento <i className="fas fa-water float-right"></i></span> */}
                                                <span className="dropdown-item mt-2" data-toggle="modal" data-target="#vindima-modal" href="#" onClick={() => rowbuttonAction('Add_Amount', dataItem)}>
                                                    Efetuar pagamento
                                                    <i className="fas fa-water float-right" />
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }

                                {
                                    actionbuttons.GroupEdit
                                    && <span data-toggle="modal" data-target="#new-group" onClick={() => rowbuttonAction('GroupEdit', dataItem)}><span title="Editar registo" className="k-icon k-i-hyperlink-open-sm mr-2" /></span>

                                }
                                {
                                    actionbuttons.detailPopUp
                                    && <span data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('detailPopUp', dataItem)}><span title="Detalhe" className="k-icon k-i-information mr-2" /></span>

                                }
                                {
                                    actionbuttons.commonPopup
                                    && <span onClick={() => rowbuttonAction(actionbuttons.commonPopup, dataItem)}><span title="Detalhe" className="k-icon k-i-information mr-2" /></span>

                                }

                                {
                                    actionbuttons.Redirect
                                    && <span onClick={() => rowbuttonAction('Redirect', dataItem)}><i title={actionbuttons.Redirect} className="fas fa-caret-square-left mt-1 ml-2 mr-3 text-yellow" /></span>

                                }
                                {
                                    actionbuttons.RedirectTwo
                                    && <span onClick={() => rowbuttonAction('RedirectTwo', dataItem)} title={actionbuttons.RedirectTwo} className="k-icon k-i-redo mr-2" />
                                }
                                {
                                   
                                    actionbuttons.AutoButton
                                   
                                    &&
                                    dataItem.codModulo == 'FISC'
                                    
                                    && <span onClick={() => rowbuttonAction('AutoButton', dataItem)} title={actionbuttons.AutoButton} className="k-icon k-i-redo mr-2" />
                                }
                                {
                                   
                                   actionbuttons.DetailsButton
                                   
                                   && <span onClick={() => rowbuttonAction('DetailsButton', dataItem)} title={actionbuttons.DetailsButton} className="k-icon k-i-information mr-2" />
                               }
                               {
                                    actionbuttons.EditButton
                                    &&
                                    dataItem.Estado != "Concluído"
                                    && <span onClick={() => rowbuttonAction('EditButton', dataItem)}><span title={actionbuttons.EditButton} className="k-icon k-i-redo cursor-pointer" /></span>

                                }
                                {
                                    actionbuttons.PdfToo
                                    &&
                                    dataItem.pdf != ''
                                    && <span onClick={() => rowbuttonAction('PdfToo', dataItem)} title={actionbuttons.PdfToo} className="fas fa-file-pdf" />
                                }
                                {
                                    actionbuttons.PdfTooAgendamento
                                    &&
                                    dataItem.comprovativoPDF != ''
                                    && <span onClick={() => rowbuttonAction('PdfTooAgendamento', dataItem)} title={actionbuttons.PdfTooAgendamento} className="fas fa-file-pdf" />
                                }
                                {
                                    actionbuttons.PdfTooFatura
                                    &&
                                    dataItem.pdfFatura != ''
                                    && <span onClick={() => rowbuttonAction('PdfTooFatura', dataItem)} title={actionbuttons.PdfTooFatura} className="fas fa-receipt" />
                                }
                                {
                                    actionbuttons.AceitarAgendamento
                                    && <span onClick={() => rowbuttonAction('AceitarAgendamento', dataItem)} title={actionbuttons.AceitarAgendamento} className="fas fa-check" />
                                }
                                {
                                    actionbuttons.TransferenciasRecusa
                                    && <span onClick={() => rowbuttonAction('TransferenciasRecusa', dataItem)} title={actionbuttons.TransferenciasRecusa} className="fas fa-times-circle" />
                                }
                                {
                                    actionbuttons.TransferenciasAceita
                                    && <span onClick={() => rowbuttonAction('TransferenciasAceita', dataItem)} title={actionbuttons.TransferenciasAceita} className="fas fa-check-circle" />
                                }
                                {
                                    actionbuttons.Desselagem
                                    &&
                                    dataItem.estado == "Terminado" && 
                                    dataItem.Auto == "Selagem" 
                                    && <span onClick={() => rowbuttonAction('Desselagem', dataItem)} title={actionbuttons.Desselagem} className="fas fa-stamp" />
                                }
                                {
                                    actionbuttons.DesbloquearAuto
                                    &&
                                    dataItem.visivel == false &&
                                    <span onClick={() => rowbuttonAction('DesbloquearAuto', dataItem)} title={"Desboquear Auto"} className="fas fa-unlock mr-2"/>
                                }
                                 {
                                    actionbuttons.MakePenhora
                                    &&
                                    
                                    <span onClick={() => rowbuttonAction('MakePenhora', dataItem)} title={"Alterar"} className="k-icon k-i-redo mr-2"/>
                                }
                                {
                                    actionbuttons.MakeNIBS
                                    &&
                                    
                                    <span onClick={() => rowbuttonAction('MakeNIBS', dataItem)} title={"Alterar"} className="k-icon k-i-redo mr-2"/>
                                }
                                {
                                    actionbuttons.PermissionRedirect
                                    && <span onClick={() => rowbuttonAction('Redirect', dataItem)} title={actionbuttons.PermissionRedirect} className="fas fa-caret-square-left  ml-2 mr-3 text-yellow" />
                                }
                                {
                                    actionbuttons.FillTransport
                                    &&
                                    dataItem.codEstadoMovimento === 3
                                    &&
                                    <span data-toggle="modal" data-target="#accept-mov-left-popup" onClick={() => rowbuttonAction("fillTransport", dataItem)}><span title={"Preencher documento"} className="fas fa-file-signature fa-2x" /></span>
                                }
                                {
                                    actionbuttons.IntroduzirRef
                                    &&
                                    dataItem.tipoMovimento === "Certificado de Procedência"
                                    &&
                                    <span data-toggle="modal" data-target="#accept-mov-left-popup" onClick={() => rowbuttonAction("IntroduzirRef", dataItem)} ><span title={"Introduzir referência do eDA"} className="fas fa-window-restore fa-2x" /></span>
                                }
                                {
                                    actionbuttons.CommonRedirection
                                    && (
                                        <>
                                            {
                                                actionbuttons.CommonRedirection === 'Mover de geral para avançado' && dataItem.entity_id
                                                && <span onClick={() => rowbuttonAction(actionbuttons.CommonRedirection, dataItem)}><span title={actionbuttons.CommonRedirection} className="k-icon k-i-redo mr-2" /></span>

                                            }
                                            
                                            {
                                                actionbuttons.CommonRedirection === 'Detalhes da Conta'
                                                && <span onClick={() => rowbuttonAction(actionbuttons.CommonRedirection, dataItem)}><span title={actionbuttons.CommonRedirection} className="k-icon k-i-redo ml-3" /></span>

                                            }
                                            {
                                                actionbuttons.CommonRedirection === "Account listing screen"
                                                &&
                                                <>
                                                    <span onClick={() => rowbuttonAction("addMovement", dataItem)}><span title={"Adicionar movimento"} className="far fa-edit" /></span>

                                                    <span onClick={() => rowbuttonAction("movementDetails", dataItem)}><span title={"Detalhes da Conta"} className="k-icon k-i-redo ml-3" /></span>
                                                </>

                                            }

                                            {
                                                actionbuttons.CommonRedirection === "Mov Aceitar"
                                                &&
                                                (dataItem.saldoCativo === 1 || dataItem.saldoCativo === "Sim")
                                                &&
                                                <>
                                                    <span data-toggle="modal" data-target="#accept-mov-left-popup" onClick={() => rowbuttonAction("acceptMovement", dataItem)}><span title={"Aceitar movimento"} className="far fa-check-circle fa-2x" /></span>
                                                </>

                                            }
                                            {
                                                actionbuttons.CommonRedirection === "Detalhes do registo"
                                                &&
                                                <>
                                                    <span onClick={() => rowbuttonAction(actionbuttons.CommonRedirection, dataItem)}><span title={actionbuttons.CommonRedirection} className="k-icon k-i-redo mr-2" data-toggle="modal" data-target='#registo-left-popup' /></span>
                                                </>
                                            }
                                            {
                                                actionbuttons.CommonRedirection !== "Detalhes do registo" &&
                                                actionbuttons.CommonRedirection !== 'Mover de geral para avançado' &&
                                                actionbuttons.CommonRedirection !== 'Detalhes da Conta' &&
                                                actionbuttons.CommonRedirection !== 'Account listing screen' &&
                                                actionbuttons.CommonRedirection !== 'Mov Aceitar' &&
                                                <span onClick={() => rowbuttonAction(actionbuttons.CommonRedirection, dataItem)}><span title={actionbuttons.CommonRedirection} className="k-icon k-i-redo mr-2" /></span>

                                            }
                                        </>
                                    )
                                }
                                {
                                    actionbuttons.DropdownRevenue
                                    && (
                                        <span>
                                            <i title="Mais opções" className="fa fa-ellipsis-v mr-2" aria-hidden="true" data-toggle="dropdown" />
                                            <div className="dropdown-menu">
                                                <span className="closetooltip"><i className="fas fa-times-circle" /></span>
                                                <span className="dropdown-item mt-2" href="#" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Processar fatura', dataItem)}>
                                                    Processar fatura
                                                    <i className="fas fa-print float-right" />
                                                </span>
                                                <span className="dropdown-item mt-2 mr-5 " href="#" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Alterar prazo de pagamento', dataItem)}>
                                                    Alterar prazo de pagamento
                                                    <i className="fas fa-map-marker float-right" aria-hidden="true" />
                                                </span>
                                                <span className="dropdown-item mt-2" href="#" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Sinalizar', dataItem)}>
                                                    Sinalizar
                                                    <i className="fa fa-history float-right" aria-hidden="true" />
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }

                                {
                                    actionbuttons.Dropdown
                                    && (
                                        <span>
                                            <i title="Mais opções" className="fa fa-ellipsis-v mr-2" aria-hidden="true" data-toggle="dropdown" />
                                            <div className="dropdown-menu">
                                                <span className="closetooltip"><i className="fas fa-times-circle" /></span>
                                                <span className="dropdown-item mt-2 mr-5 " data-toggle="modal" data-target="#google-map-popup" onClick={() => rowbuttonAction('Map', dataItem)}>
                                                    Ver no mapa
                                                    <i className="fas fa-map-marker float-right" aria-hidden="true" />
                                                </span>
                                                <span className="dropdown-item mt-2" data-toggle="modal" data-target="#parcelPopups" onClick={() => rowbuttonAction('History', dataItem)}>
                                                    Histórico
                                                    <i className="fa fa-history float-right" aria-hidden="true" />
                                                </span>
                                                <span className="dropdown-item mt-2" href="#" onClick={() => rowbuttonAction('Print', dataItem)}>
                                                    Imprimir
                                                    <i className="fas fa-print float-right" />
                                                </span>
                                                <span className="dropdown-item mt-2" href="#" onClick={() => rowbuttonAction('remind', dataItem)}>
                                                    Rendimento
                                                    <i className="fas fa-water float-right" />
                                                </span>

                                            </div>
                                        </span>
                                    )
                                }

                                {
                                    actionbuttons.LabelEditButton1 &&
                                    ((actionbuttons.LabelEditButton1 === 'processOrder1' || dataItem.numeroAvaliacao == 1) ?
                                        <span onClick={() => rowbuttonAction("processOrder1", dataItem)}><span title="Consultar registo" className="k-icon k-i-redo cursor-pointer" /></span>
                                        :
                                        <span onClick={() => rowbuttonAction(actionbuttons.LabelEditButton1, dataItem)}><span title="Consultar registo" className="k-icon k-i-redo cursor-pointer" /></span>)

                                    // <span>
                                    //     <i title="Mais opções" className="fa fa-ellipsis-v mr-2" aria-hidden="true" data-toggle="dropdown"></i>
                                    //     <div className="dropdown-menu" >
                                    //         <span className="closetooltip"><i className="fas fa-times-circle"></i></span>
                                    //         {
                                    //           (actionbuttons.LabelEditButton1 === 'processOrder1' || dataItem.numeroAvaliacao == 1) ? 
                                    //           <span className="dropdown-item mt-2 mr-5 " onClick={() => rowbuttonAction("processOrder1", dataItem)} >Pedido de Processo <i class="fa fa-spinner float-right" aria-hidden="true"></i></span>
                                    //           :
                                    //           <span className="dropdown-item mt-2 mr-5 " onClick={() => rowbuttonAction(actionbuttons.LabelEditButton1, dataItem)} >Pedido de Processo <i class="fa fa-spinner float-right" aria-hidden="true"></i></span>
                                    //         }
                                    //     </div>
                                    // </span>
                                }
                                {
                                    actionbuttons.TranferenciasDetalhe
                                    && <span onClick={() => rowbuttonAction('TranferenciasDetalhe', dataItem)}><span title="Consultar Detalhe da Transferência" className="k-icon k-i-redo cursor-pointer" /></span>

                                }
                                {/* {
                                    actionbuttons.TranferenciasDetalhe &&
                                    ((actionbuttons.TranferenciasDetalhe === 'TranferenciasDetalhe' || dataItem.numeroAvaliacao == 1) ?
                                        <span onClick={() => rowbuttonAction("TranferenciasDetalhe", dataItem)}><span title="Consultar Detalhe da Transferência" className="k-icon k-i-redo ml-3" /></span>
                                        :
                                        <span onClick={() => rowbuttonAction(actionbuttons.TranferenciasDetalhe, dataItem)}><span title="Consultar Detalhe da Transferência" className="k-icon k-i-redo ml-3" /></span>)
                                } */}
                                {/* {
                                  actionbuttons.ImagePreview && 
                                    <span data-toggle="modal" data-target="#popup-image-preview" onClick={() => rowbuttonAction("ImagePreview", dataItem)}  >
                                      <i title={"imagem de visualização"} class="fas fa-image"></i>
                                    </span>
                                } */}
                                {
                                    actionbuttons.LabelDropdown &&
                                    <span>
                                        <i title="Mais opções" className="fa fa-ellipsis-v ml-3" data-toggle="dropdown"></i>
                                        <div className="dropdown-menu" >
                                            <span className="closetooltip"><i className="fas fa-times-circle"></i></span>
                                            <span className="dropdown-item mt-2 mr-5 " onClick={() => rowbuttonAction("aprovados", dataItem)} >Detalhes</span>
                                            <span className="dropdown-item mt-2 mr-5 " onClick={() => rowbuttonAction("transferOrder", dataItem)} >Transferência</span>
                                        </div>
                                    </span>
                                }
                                {
                                    actionbuttons.Delete &&
                                    <DeleteModal handleDelete={(id) => deleteFunc(id)} row={dataItem} className=" ml-3" />
                                }

                                {
                                    actionbuttons.AllFile
                                    && (
                                        <span>
                                            <i title="Todo o documento" className="fa fa-copy mr-2" aria-hidden="true" data-toggle="dropdown" />
                                            {
                                                this.props.dataItem.invoiceHistory.reverse().map((data, index) => (
                                                    data.file_Link && data.invoiceType
                                                    && (
                                                        <div className="dropdown-menu">
                                                            <span className="closetooltip"><i className="fas fa-times-circle" /></span>
                                                            <span
                                                                onClick={() => services.goto.newTab(data.file_Link ? `/api/${data.file_Link.replace('file:///C:/DevelopmentIVPD', '')}` : '')}
                                                                className="dropdown-item mt-2 cursor-pointer"
                                                            >
                                                                {`${data.invoiceType}_${data.transection_Date}`}
                                                                {' '}
                                                                <i className="k-icon k-i-file-txt mr-2" />
                                                            </span>
                                                        </div>
                                                    )
                                                ))
                                            }
                                        </span>
                                    )

                                }
                                {
                                    actionbuttons.Popup
                                    && (
                                        <Tooltip title="Detalhe" color="#808080">
                                            <span data-toggle="modal" data-target="#left-popup-center" onClick={() => rowbuttonAction('detailsPopup', dataItem)}><span className="k-icon k-i-information" /></span>
                                        </Tooltip>
                                    )

                                }

                                {
                                    actionbuttons.File && dataItem.document_url
                                    && <i onClick={() => services.goto.newTab(dataItem.document_url)} title={actionbuttons.File} className="fas fa-file-alt cursor-pointer" />
                                }

                                {
                                    actionbuttons.Invoice_File && dataItem.invoice_url
                                    && (
                                        <i
                                            onClick={() => services.goto.newTab(dataItem.invoice_url)}
                                            title={actionbuttons.File}
                                            className="fas fa-file-alt cursor-pointer"
                                        />
                                    )

                                }
                                {
                                    actionbuttons.instalacaoEdit && (
                                        <>
                                            <span
                                                data-toggle="modal" data-target='#left-popup-center'
                                                onClick={() => rowbuttonAction('vasilhaEdit', dataItem)}
                                                title={actionbuttons.instalacaoEdit}
                                                className="k-icon k-i-redo cursor-pointer"
                                            ></span>
                                            <span
                                                onClick={() => rowbuttonAction('vasilhaRemove', dataItem)}
                                                title={actionbuttons.removeVasilha}
                                                className="k-icon k-i-delete cursor-pointer text-inactive ml-2"
                                            ></span>
                                        </>
                                    )
                                }
                                {
                                    actionbuttons.IVVvalidate && dataItem.existeNaBD == true && dataItem.existeNaBDAgente == false &&(
                                        <span
                                            onClick={() => rowbuttonAction('AddAgente', dataItem)}
                                            className="fas fa-check"
                                            title = "Adicionar utilizador"
                                        ></span>
                                    )
                                }
{
                                    actionbuttons.IVVvalidate && dataItem.existeNaBD == false && (
                                        <span
                                            onClick={() => rowbuttonAction('insert', dataItem)}
                                            title={actionbuttons.IVVvalidate}
                                            className="k-icon k-i-redo cursor-pointer"
                                        ></span>
                                    )
                                }


                                {/* Selos is here --------------------------------------------- */}

                                {
                                    actionbuttons.module === "selos" && dataItem.idEstado === 1 &&
                                    <span
                                    onClick={() => this.actionSelosPedidos(dataItem)}
                                    title={actionbuttons.selosActionApproved}
                                    className="k-icon k-i-redo cursor-pointer"
                                    ></span>
                                }
                                {
                                    actionbuttons.module === "selos" && dataItem.idEstado != 1 &&
                                    <span
                                            // onClick={() => rowbuttonAction(actionbuttons.action, dataItem)}
                                            title={actionbuttons.selosActionApproved}
                                            className="k-icon k-i-redo cursor-pointer"
                                            data-toggle="modal"
                                            data-target='#selos-graficas-popup'
                                        ></span>
                                }
                                {
                                    actionbuttons.module &&
                                    actionbuttons.module === "marcas" &&
                                    <> <span
                                        data-toggle="modal"
                                        // data-target='#selos-popup' 
                                        onClick={() => rowbuttonAction(actionbuttons.action, dataItem)}
                                        // title={actionbuttons.selosActionApproved}
                                        title="Detalhes"
                                        className="k-icon k-i-redo cursor-pointer"
                                    ></span></>
                                }

                                {
                                    actionbuttons.selosStampActionApproved && (
                                        <i
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('stampApproved', dataItem)}
                                            title={actionbuttons.selosStampActionApproved}
                                            className="k-icon k-i-redo cursor-pointer"
                                        />
                                    )
                                }
                                {
                                    actionbuttons.graphicasPending && (
                                        <i
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('graphicasPending', dataItem)}
                                            title={actionbuttons.graphicasPending}
                                            className="k-icon k-i-redo cursor-pointer"
                                        />
                                    )
                                }
                                {
                                    actionbuttons.graphicasAssinalados && (
                                        <>
                                            <i
                                                data-toggle="modal" data-target='#selos-popup'
                                                onClick={() => rowbuttonAction('assinalodoForm', dataItem)}
                                                title="Form"
                                                className="k-icon k-i-form-element cursor-pointer mr-2"
                                            />
                                            <i
                                                data-toggle="modal" data-target='#selos-popup'
                                                onClick={() => rowbuttonAction('graphicasPending', dataItem)}
                                                title={actionbuttons.graphicasPending}
                                                className="k-icon k-i-redo cursor-pointer"
                                            />
                                        </>
                                    )
                                }

                                {
                                    actionbuttons.selosStampActionPending && (
                                        <span
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('stampPending', dataItem)}
                                            title={actionbuttons.selosStampActionPending}
                                            className="k-icon k-i-redo cursor-pointer"
                                        ></span>
                                    )
                                }

                                {
                                    actionbuttons.selosStampActionSuspended && (
                                        <i
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('stampSuspended', dataItem)}
                                            title={actionbuttons.selosStampActionSuspended}
                                            className="k-icon k-i-redo cursor-pointer"
                                        />
                                    )
                                }

                                {
                                    actionbuttons.selosStampActionRejected && (
                                        <i
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('stampRejected', dataItem)}
                                            title={actionbuttons.selosStampActionRejected}
                                            className="k-icon k-i-redo cursor-pointer"
                                        />
                                    )
                                }
                                {
                                    actionbuttons.affixingSeals && (
                                        <i
                                            data-toggle="modal" data-target='#selos-popup'
                                            onClick={() => rowbuttonAction('affixingPopup', dataItem)}
                                            title={actionbuttons.affixingSeals}
                                            className="k-icon k-i-redo cursor-pointer"
                                        />
                                    )
                                }


                                {/* Selos ends ---------------------------------------- */}



                                {
                                    actionbuttons.AdministrationDelete && (
                                        <ConfirmationModal handleConfirmation={(data) => deleteFunc(data)} row={dataItem} useFor={actionbuttons.AdministrationDelete} />
                                    )
                                }

                            </div>
                        </Tooltip>

                    </td>
                );
            }
            return (
                <td />
            );
        }
    };
}
